import { render, staticRenderFns } from "./qs1-02.vue?vue&type=template&id=0a600b7e&scoped=true&"
import script from "./qs1-02.vue?vue&type=script&lang=js&"
export * from "./qs1-02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a600b7e",
  null
  
)

export default component.exports